import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';


const PTA = () => {
  return (
    <>
      <Box height={100} />

      <Grid container spacing={0} alignItems="center" justify="center">
        <Grid item xs={2} />
          <Grid item xs={8}>
            <Card>
              <CardHeader title='家长教师协会（PTA）主页面 (创建中...)'/>
              <CardContent>

                <Box textAlign={'center'}>
                  <Typography>
                    家长教师协会 (PTA) 旨在促进家长、教师和学校之间的合作与沟通，以支持学生的学业和全面发展。PTA 组织各种活动和项目，旨在增强学校社区的凝聚力，提供资源和支持，帮助学生在学术、社交和情感方面取得成功。通过参与 PTA，家长和教师可以共同努力，为学生创造一个积极和有益的学习环境。

                  </Typography>
                </Box>
                <br />
                <br />
                <Box textAlign={'left'}>
                    <a href="/school-calendar" >学校日历</a>
                </Box>

              </CardContent>
              </Card>
          </Grid> 
        <Grid item xs={2} />
      </Grid>
      
      <Box height={80} />
    </>
  )
}

export default PTA